<script setup lang="ts">
// oxlint-disable-next-line import/no-unassigned-import
import 'swiper/css'

import {Swiper, SwiperSlide} from 'swiper/vue'
import type {Project} from '~/types/legacy'
import type {Populated} from '~/types/populated'

defineProps<{
  projects: Populated<Project>[]
}>()
</script>

<template>
  <Container class="screen-content flex flex-col items-center !overflow-visible px-2">
    <swiper
      :grabCursor="true"
      :centeredSlidesBounds="true"
      slidesPerView="auto"
      spaceBetween="16"
      :autoHeight="true"
      class="projects-slider !overflow-visible"
    >
      <swiper-slide v-for="(item, i) in projects" :key="item.id" :index="i" class="!w-auto">
        <ProjectsSlide :project="item" />
      </swiper-slide>
    </swiper>
  </Container>
</template>

<style>
.projects-slider .swiper-slide {
  width: auto !important;
  height: auto !important;
}
</style>
